import { WSButton, WSElement, WSText } from "@wingspanhq/fe-component-library";
import { Payable } from "@wingspanhq/wingspan-api-sdk";
import { queriesWorkItems, queriesWorkLogs } from "@query";
import { useHistory } from "react-router-dom";
import { routeHelpersWorkLogPayerDetails } from "../../modules/WorkLogs/paths";

type Props = {
  payable: Payable;
};

export const PayableWorkLog: React.FC<Props> = ({ payable }) => {
  const history = useHistory();

  const workItemId = payable?.lineItems?.[0]?.metadata?.workItemId as
    | string
    | undefined;

  const queryWorkItem = queriesWorkItems.getWorkItem.useQuery(
    { workItemId: workItemId ?? "" },
    { enabled: !!workItemId }
  );

  const workLogId = queryWorkItem.data?.workLogId;

  const queryWorkLog = queriesWorkLogs.getWorkLog.useQuery(
    { workLogId: workLogId ?? "" },
    { enabled: !!workLogId }
  );

  if (!workLogId || !queryWorkLog.data?.workLogNumber) {
    return null;
  }

  return (
    <WSElement>
      <WSText.ParagraphSm color="gray500">
        Created from work log{" "}
        <WSButton.Link
          onClick={() =>
            history.push(
              routeHelpersWorkLogPayerDetails.createLocationObject({
                workLogId
              })
            )
          }
        >
          #{queryWorkLog.data.workLogNumber}
        </WSButton.Link>
      </WSText.ParagraphSm>
      <WSButton.Link
        mt="M"
        onClick={() =>
          history.push(
            routeHelpersWorkLogPayerDetails.createLocationObject({ workLogId })
          )
        }
        rightIcon="chevron-right"
      >
        View work log
      </WSButton.Link>
    </WSElement>
  );
};
